import './Benefits.scss';
import { useEffect } from 'react';
import BenefitsAdditionalContent from '../../../components/BenefitsAdditionalContent/BenefitsAdditionalContent';
import BenefitsCoupons from '../../../components/BenefitsCoupons/BenefitsCoupons';
import BenefitsNewServicing from '../../../components/BenefitsNewServicing/BenefitsNewServicing';
import DiscoverHeader from '../../../components/DiscoverHeader/DiscoverHeader';
import FeaturedBenefits from '../../../components/FeaturedBenefits/FeaturedBenefits';
import { useTranslation } from 'react-i18next';

const Benefits = () => {
  const {t} = useTranslation();
  const json = t('ndc-program.benefits',{returnObjects: true});
 

  const discoverHeader = {
    breadcrumb: json['section.header'].breadcrumb,
    image: 'benefits.png',
    headerHtmlString: t('benefits_header')
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const couponRef: any[] = [];

  useEffect(() => {
    if (window.location.search) {
      const goto = window.location.search.replace('?', '');

      if (goto === 'coupon') {
        couponRef[0] &&
          couponRef[0].scrollIntoView({
            block: 'center'
          });
      }
    }
  }, [couponRef,t]);
 
  return (
    <>
      {json && (
        <main className="benefits-container">
          <DiscoverHeader {...discoverHeader} />
          <FeaturedBenefits data={t('benefits_featured_benefits',{returnObjects: true, defaultValue:[]})[0]} />
          <hr className="divider" />
          <div className="benefits-ns-ac-container">
            <BenefitsNewServicing data={t('benefits_functions',{returnObjects: true, defaultValue:[]})[0]} />
            <BenefitsAdditionalContent
              data={t('benefits_additional_content',{ returnObjects: true, defaultValue:[]})[0]}
            />
          </div>
          <div ref={(el) => couponRef.push(el)}>
            <BenefitsCoupons />
          </div>
        </main>
      )}
    </>
  );
};

export default Benefits;
